export const linkedInGettingStartedArticle = {
  title: 'LinkedIn Enhancer: Getting Started',
  slug: 'linkedin-getting-started',
  content: `LinkedIn Enhancer: Getting Started

Manage personal and business LinkedIn profiles in one workspace.

1) Open the LinkedIn hub
- Go to /linkedin-hub.
- Tabs are controlled by URL hash (#personal or #business).

2) Choose profile type
- Personal Profile: optimize your founder profile.
- Business Profile: update company profile content.

3) Switch tabs
- Use the tab bar to move between personal and business views.
`,
};
